module.exports = __webpack_public_path__ + "img/maps-and-location.a5dcb1fd.svg";